import { Flex, Typography } from 'antd'

import { queryBankPageApi } from '@eastcoal/api/finance/bank/queryBankPage'
import { BankEntity } from '@eastcoal/api/finance/interface'

import { RemoteSelect } from '@eastcoal/common/components/RemoteSelect'
import { SelectMode } from '@eastcoal/common/components/RemoteSelect/interface'
import { formatBankCard } from '@eastcoal/common/utils/bankCard'

import { BankAccountSelectProps } from './interface'

const AccountItem = ({ item }: { item: BankEntity }) => {
  return (
    <Flex gap={4}>
      <Typography.Text>{formatBankCard(item.bankAccount)}</Typography.Text>
      <Typography.Text
        ellipsis={{ tooltip: { title: item.bankName, placement: 'right' } }}
        style={{ maxWidth: 200 }}
        type='secondary'
      >
        {item.bankName}
      </Typography.Text>
    </Flex>
  )
}

const resolveOptions = (value?: BankEntity[]) =>
  value?.map(item => ({
    label: <AccountItem item={item} />,
    value: item?.bankAccount
  }))

const getOptionValue = (value: BankEntity) => `${value.bankAccount}`

export const BankAccountSelect = <M extends SelectMode>({
  memberId,
  allowClear = true,
  ...restProps
}: BankAccountSelectProps<M>) => {
  return (
    <RemoteSelect
      {...restProps}
      allowClear={allowClear}
      api={queryBankPageApi}
      getOptionValue={getOptionValue}
      readyRequest={!!memberId}
      refreshDeps={[memberId]}
      requestParams={{ memberId }}
      resolveOptions={resolveOptions}
    />
  )
}
